export const companiesListLoading = state => state.company.listLoading;
export const companiesListData = state => state.company.listData;
export const companiesListFetched = state => state.company.listFetched;

export const companiesCurrentItem = state => state.company.currentItem;
export const companiesCurrentItemLoading = state => state.company.itemLoading;
export const companiesCurrentItemErrors = state => state.company.errors;

export const deleteInProcessSelector = state => state.company.deleteInProcess;

export const companiesUpdateOrCreateInProcess = state => state.company.createOrUpdateInProcess;
